import React from 'react';

import styles from "../../../styles/game-center-header-status.module.scss";
import classNames from "classnames";
import {observer} from "mobx-react";
export const GameCenterHeaderModuleDetailsAddedTime = observer(({controller}) => {
  const {state} = controller;
  const {addedTime} = state;

  return addedTime ? <bdi className={classNames(styles.added_time)}>{addedTime}</bdi> : null
});
